import {combineReducers, configureStore} from "@reduxjs/toolkit";
import ApplicationReducer from "../store/reducers/reducers"
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
const rootReducer = combineReducers({
    app: ApplicationReducer
})

export const store = configureStore({
    reducer: rootReducer
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
